"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralProgramEventType = void 0;
var ReferralProgramEventType;
(function (ReferralProgramEventType) {
    ReferralProgramEventType["ReferralEvent"] = "ReferralEvent";
    ReferralProgramEventType["ReferralProgram"] = "ReferralProgram";
    ReferralProgramEventType["ReferralReward"] = "ReferralReward";
    ReferralProgramEventType["ReferralWithdraw"] = "ReferralWithdraw";
    ReferralProgramEventType["ReferralBonus"] = "ReferralBonus";
})(ReferralProgramEventType || (exports.ReferralProgramEventType = ReferralProgramEventType = {}));
//# sourceMappingURL=referral.js.map